import React, { useState, createContext, useEffect } from 'react';
import {UserService} from "../services/user-service";
import { useHistory } from "react-router-dom";

const UserContext = createContext([{}, () => {}]);

const UserProvider = (props) => {
    const [data, setData] = useState({
        name: "",
        email: "",
        location_name: "",
        location_id: null,
        locations: [],
        selected: null,
        token: null
    });

    const history = useHistory();

    function makeLogout() {
        localStorage.removeItem('provider_token');
        localStorage.removeItem('provider_data');
        localStorage.removeItem('location_data');
        history.push("/");
    }

    useEffect(()=> {
        async function getData() {
            let provider_token = await localStorage.getItem('provider_token');
            const provider_data = localStorage.getItem('provider_data');
            if(!data.token && !provider_data) {
                UserService.me(provider_token).then((result)=> {
                    if(result.data) {
                        result.data.token = provider_token;
                        localStorage.setItem('provider_data', JSON.stringify(result.data));
                    } else {
                        makeLogout();
                    }

                    UserService.locations(provider_token).then((r) => {
                        if(r.total > 0) {
                            setData({
                                ...data, 
                                token: provider_token,
                                locations: r.locations,
                                name: result.data ? result.data.name : "Medicare Club",
                                email: result.data ? result.data.email : "club@medicare.ao",
                                location_name: r.locations[0].commercial_name,
                                location_id: r.locations[0].location_id,
                                selected: r.locations[0],
                                provider_id: result.data.customer_id
                            });
                            localStorage.setItem('location_data', JSON.stringify(r.locations[0]));
                        }
                    }, ()=> {makeLogout();});
                }, ()=> {makeLogout();});
            } else if(!data.token && provider_data) {
                const provider_d = JSON.parse(localStorage.getItem('provider_data'));
                const location_data = JSON.parse(localStorage.getItem('location_data'));
                UserService.locations(provider_token).then((r) => {
                    if(r.total > 0) {
                        setData({
                            ...data, 
                            token: provider_token,
                            locations: r.locations,
                            name: provider_d.name,
                            email: provider_d.email,
                            provider_id: provider_d.provider_id,
                            location_name: location_data?.commercial_name ? location_data.commercial_name : r.locations[0].commercial_name,
                            location_id: location_data?.location_id ? location_data.location_id : r.locations[0].location_id,
                            selected: location_data ? location_data : r.locations[0]
                        });
                    }
                }, ()=> {makeLogout();});
            }
        }
        getData();
    }, []);

    return <UserContext.Provider value={[data, setData]}>{props.children}</UserContext.Provider>
}

export { UserContext, UserProvider };